export const TOGGLE_LOCATION_FILTER_MENU = 'ibw/SearchLocations/TOGGLE_LOCATION_FILTER_MENU';
